export default __webpack_public_path__ + "static/media/hand-guns.662b5fb6.svg";